$(function () {
  // 在这里编写需要在文档加载完成后执行的代码
  if (!customElements.get('scenario-rv-ads')) {
    customElements.define(
      'scenario-rv-ads',
      class ScenarioRvAds extends HTMLElement {
        swiper = null;
        constructor() {
          super();
        }

        connectedCallback() {
          this.init();
        }

        init() {
          const $mySwiper = this.querySelector('.scenario-rv-ads_swiper');
          const advantagePrev = this.querySelector('.scenario-rv-ads_prev');
          const advantageNext = this.querySelector('.scenario-rv-ads_next');
          const $scrollbarDom = this.querySelector('.swiper-scrollbar');
          const $pagination = this.querySelector('.scenario-rv-ads__pagination');
          // 自动轮播
          this.swiper = new Swiper($mySwiper, {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 16,
            centeredSlides: true,
            effect: 'fade',
            speed: 600,
            fadeEffect: {
              crossFade: true,
            },
            autoplay: {
              delay: 5000,
              disableOnInteraction: false,
            },
            navigation: {
              nextEl: advantageNext,
              prevEl: advantagePrev,
            },
            pagination: {
              el: $pagination,
              clickable: false,
              type: 'bullets',
            },
            scrollbar: {
              el: $scrollbarDom,
              draggable: true,
            },
            on: {
              autoplayTimeLeft(_s, _time, progress) {
                requestAnimationFrame(() => {
                  $($pagination).css('--progress', `${(1 - progress) * 100}%`);
                });
              },
            },
          });

          // 自动轮播
          this.swiper.autoplay.start();
        }
      }
    );
  }
});
